import type { TFunction } from 'i18next';
import { formatPrice } from '@ooh/ui/lib/media-unit-formatters';
import type { MediaUnitColumnDef } from './columns';

/**
 * Builds the 7 hidden-by-default client-price columns — extracted so
 * `buildExtendedColumns` stays within the file's max-lines-per-function
 * budget. Never masked (`cost.view` gates internal costs, never client
 * prices — discountedPrice/lastMinutePrice/starterPrice were corrected into
 * this group from the internal-cost group, permission-model correction,
 * CU-86cbgnt38 round 4).
 */
export function buildClientCostColumns(t: TFunction<'inventory', undefined>): MediaUnitColumnDef[] {
  return [
    {
      id: 'discountedPrice',
      label: t('table.columns.discountedPrice'),
      align: 'right',
      width: 130,
      sortable: true,
      sortKey: 'discountedPrice',
      renderCell: (item) => (
        <span className="font-mono text-xs">{formatPrice(item.discountedPrice)}</span>
      ),
    },
    {
      id: 'lastMinutePrice',
      label: t('table.columns.lastMinutePrice'),
      align: 'right',
      width: 130,
      sortable: true,
      sortKey: 'lastMinutePrice',
      renderCell: (item) => (
        <span className="font-mono text-xs">{formatPrice(item.lastMinutePrice)}</span>
      ),
    },
    {
      id: 'starterPrice',
      label: t('table.columns.starterPrice'),
      align: 'right',
      width: 110,
      sortable: true,
      sortKey: 'starterPrice',
      renderCell: (item) => (
        <span className="font-mono text-xs">{formatPrice(item.starterPrice)}</span>
      ),
    },
    {
      id: 'clientProduction',
      label: t('table.columns.clientProduction'),
      align: 'right',
      width: 110,
      sortable: true,
      sortKey: 'clientProduction',
      renderCell: (item) => (
        <span className="font-mono text-xs">{formatPrice(item.clientProduction)}</span>
      ),
    },
    {
      id: 'clientInstallation',
      label: t('table.columns.clientInstallation'),
      align: 'right',
      width: 110,
      sortable: true,
      sortKey: 'clientInstallation',
      renderCell: (item) => (
        <span className="font-mono text-xs">{formatPrice(item.clientInstallation)}</span>
      ),
    },
    {
      id: 'clientDismantling',
      label: t('table.columns.clientDismantling'),
      align: 'right',
      width: 110,
      sortable: true,
      sortKey: 'clientDismantling',
      renderCell: (item) => (
        <span className="font-mono text-xs">{formatPrice(item.clientDismantling)}</span>
      ),
    },
    {
      id: 'clientAdditionalFees',
      label: t('table.columns.clientAdditionalFees'),
      align: 'right',
      width: 140,
      sortable: true,
      sortKey: 'clientAdditionalFees',
      renderCell: (item) => (
        <span className="font-mono text-xs">{formatPrice(item.clientAdditionalFees)}</span>
      ),
    },
  ];
}
